// extracted by mini-css-extract-plugin
export default {"link":"link--iNQ7J","underline":"underline--Qe_sP","black":"black--DhhO6","darkBlue":"darkBlue--tC00f","disabled":"disabled--kl_ff","gray":"gray--oIFpN","ai-red":"ai-red--E1Nbz"};